<template>
  <div v-if="hasTranscript">
    <font-awesome-icon :icon="['fas','file']" class="cursor-pointer" @click="show_modal_click" />
    <Teleport to="body">
      <div v-if="show_modal" class="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
        <div class="bg-white rounded-lg shadow p-5 mx-52" >
          <div>
            <Transcript_Summary :transcript-summary="params.data.engagement_transcription_summary"/>
          </div>
          <div class="flex justify-end mt-4 pt-3 border-t">
            <button
              @click="close_modal"
              class="btn-primary"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import Transcript_Modal from '@/components/widgetcomponents/JSON_Editors/Transcript_Modal.vue'
import Transcript_Summary from "@/components/widgetcomponents/JSON_Editors/Transcript_Summary.vue";

export default {
  components: {Transcript_Summary, FontAwesomeIcon, Transcript_Modal},
  props: {
  },
  data(){
    return {
      show_modal:false
    }
  },
  computed: {
    hasTranscript(){
      return this.params.data.engagement_transcription_summary != null
    },
    isGroup() {
      return this.params.node.group
    },
    displayValue() {
      return this.params.value
    },
    groupLevel() {
      return this.params.node.level
    },
    groupField() {
      const groupingFields = this.params.api.getRowGroupColumns().map(col => col.getColId())
      return groupingFields[this.groupLevel]
    },
    groupIdField() {
      return `${this.groupField.replace('_name', '_id')}`
    },
    groupId() {
      return this.params.node.aggData[this.groupIdField]
    }
  },
  methods: {
    show_modal_click(){
      this.show_modal = true
    },
    close_modal(){
      this.show_modal = false
    }
  },
  mounted() {
  }
}
</script>
